import { FilterSearchingBaseViewModel, PagingResultsViewModel } from '../../../core/_infrastructure/types/common';

export class AlertaMatriculaViewModel {
    public IdSolicitud: number;
    public Codigo: string;
}

export class AlertaMatriculaItemResultsViewModel extends PagingResultsViewModel {
    public ResultList: AlertaMatriculaItemViewModel[];
}

export class AlertaMatriculaItemViewModel {
    public IdSolicitud: number;
    public Codigo: string;
    public FechaEnvio: Date;
    public Matricula: string;
    public EsRechazo: boolean;
}

export class FilterSearchingAlertaMatriculaViewModel extends FilterSearchingBaseViewModel {
    public Codigo: string;
    public FechaEnvio: Date;
    public Matricula: string;
    public EsRechazo: boolean;
}
